
import UniversalLink from '~/pages/_lang/universal-link/qr/login/index.vue'
export default UniversalLink
